module.exports = __webpack_public_path__ + "img/logo.048b2914.png";